const url = '/queues';
const Provider = 'Queues';
const dbModel = 'Queues';

export { url, Provider, dbModel };
